import { selfAxios } from "@oppein/op-utils";

export async function reqGetOrgBrandCategory(params) {
  const { data } = await selfAxios.get(
    "/designapi/design/insideProcessOrder/getOrgBrandCategory",
    { params },
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designapi/design/insideProcessOrder/getOrgBrandCategory/get.js